module.exports = __webpack_public_path__ + "img/ds_hs5.9be55321.png";